import React from 'react'
import Link from 'gatsby-link'
import Slider from 'react-slick'

import "../../../node_modules/slick-carousel/slick/slick.css"
import rocketSymbol from './../../images/mb/rocket_link.png'

export default class FeaturedProjectSlider extends React.Component {
  next = () => this.slider.slickNext();
  previous = () => this.slider.slickPrev();

  getUrl = (url) => {
    let parts = url.split('/');
    if (parts[(parts.length - 1)] !== "") {
      return parts[(parts.length - 1)]
    } else {
      return parts[(parts.length - 2)]
    }
  }

  render() {
    const { slides } = this.props;
    const settings = {
      // dots: true,
      // infinite: false,
      arrows: false,
      // lazyLoad: true,
    };

    return (
      <section className="no-padding case-study bg-gray wow fadeIn featured-project-slider">
        <div className="container-fluid">
          <div className="row">
            <div id="featuredProjectSlider" className="owl-theme dark-pagination" >
              <Slider ref={c => (this.slider = c)} {...settings}>
  
                {slides.map((a, i) => (
                  <div className="item" key={i}>
                    <div className="col-lg-6 col-md-6 no-padding">
                      <img className="featuredSliderImg" src={a.image.localFile.childImageSharp.resolutions.src} />
                    </div>
                    <div className="col-lg-6 col-md-6 no-padding xs-text-center">
                      <img className="featured-background-2 featuredSliderImg" src={a.image2.localFile.childImageSharp.resolutions.src} alt="" />
                      <div className="case-study-content row">
                        <div className="top-row row">
                          <div className="col-sm-4 no-padding hidden-xs">
                            <img className="counter-img" src={a.number_image.localFile.childImageSharp.resolutions.src} />
                          </div>
                          <div className="col-sm-8 col-xs-12">
                            <h2>{a.title}</h2>
                            <p>{a.labels}</p>
                            <p>{a.description}</p>
                          </div>
                        </div>
                        <div className="row featuredProject_linkRow">
                          <div className="col-sm-8 col-sm-offset-4 featuredProject_link">
                            <Link to={`projects/${this.getUrl(a.link)}`}>
                              <span className="btn btn-small highlight-button-red">View Project</span>
                              <img className="counter-img hidden-xs" style={{display: 'inline-block', marginLeft: 8}} src={rocketSymbol} />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
              <button className="slickNavButton slickNavButton--prev" onClick={this.previous}></button>
              <button className="slickNavButton slickNavButton--next" onClick={this.next}></button>
            </div>
          </div>
        </div>
      </section>
    )
  }
  
}


// WEBPACK FOOTER //
// ./src/components/FeaturedProjectSlider/index.js